import { createClient } from '@blinkdotnew/sdk';

function getProjectId(): string {
  const envId = import.meta.env.VITE_BLINK_PROJECT_ID;
  if (envId) return envId;
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  const match = hostname.match(/^([^.]+)\.sites\.blink\.new$/);
  if (match) return match[1];
  return 'sargo-09-119-98va6f1d';
}

export const blink = createClient({
  projectId: getProjectId(),
  publishableKey: import.meta.env.VITE_BLINK_PUBLISHABLE_KEY || 'blnk_pk_KS1jKUTpa6RS1b07ILdcW90MU-WD6UPD',
  authRequired: false,
  auth: { mode: 'managed' },
});
